<template>
  <validation-observer ref="simpleRules">
    <item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>
<script>
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ItemForm from '@/views/Admin/Account_activities/Expenses/ItemForm.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import toastMixin from '@/libs/toast'

export default {
  name: 'AccountExpenseEdit',
  components: {
    ItemForm,
    SaveButton,
    ValidationObserver,
  },
  mixins: [toastMixin],
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
    saveData() {
      return this.$store.getters['accountActivities/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'saveSuccess' })
      } else if (val.status === false) {
        this.showToast({ template: 'saveError' })
      }
    },
  },
  created() {
    this.$store.commit('accountActivities/RESET_DATA_ITEM')
    localize('tr')
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('accountActivities/getDataItem', this.$route.params.id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('accountActivities/saveData', this.dataItem)
            .then(response => {
              if (response.status) {
                this.$router.push('/app/account-activities')
              }
            })
        } else {
          this.showToast({ template: 'requireWarning' })
        }
      })
    },
  },
}
</script>
